// [ai] The media focus arbiter (docs/ARCHITECTURE.md "Media rule"): one owner of playback. A widget with its own sound takes
// focus — the host pauses (and remembers whether it was playing), a previous owner is told to pause — and releases it: the host
// resumes if it was playing before the first focus. The host starting again pauses the owner and ends the focus. Pure.
export type FocusHost = { playing(): boolean; pause(): void; resume(): void };
export type Owner = { id: string; pause(): void };
export function createArbiter(host: FocusHost) {
  let owner: Owner | null = null; let resumeHost = false;
  return {
    get owner(): string | null { return owner?.id ?? null; },
    focus(o: Owner) {
      if (owner?.id === o.id) return;
      if (owner) owner.pause(); else { resumeHost = host.playing(); if (resumeHost) host.pause(); }
      owner = o;
    },
    release(id: string) { if (!owner || owner.id !== id) return; owner = null; if (resumeHost) { resumeHost = false; host.resume(); } },
    /** The host player started on its own: the widget's clip yields, nothing to resume later. */
    hostStarted() { if (!owner) return; owner.pause(); owner = null; resumeHost = false; },
    /** A widget went away: whatever it held is released. */
    drop(id: string) { this.release(id); },
  };
}
export type Arbiter = ReturnType<typeof createArbiter>;
